import { DocsExamples } from "@/types/docs-reference";

export const examples: DocsExamples = {};
